import React from 'react';
import ReactDOM from 'react-dom';
import Main from './components/Main';

// App css
//import 'style!css!applicationStyles';

import './styles/app.css'

ReactDOM.render(
    <Main />, 
    document.getElementById("react-container")
);